export { default } from './ReviewSubjectLink';
